import algoliasearch from "algoliasearch";

/**
  * Saved Content handler
  *
  */
const CwkSavedContent = ($) => {

  if (!window.Tangible) return

  const tangibleSelect = window.Tangible.Select
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig

  const tgblCWKFrontend_json = window.atob(tgblCWKFrontend_e)
  const tgblCWKFrontend = jQuery.parseJSON(tgblCWKFrontend_json)
  const LOCALIZED = tgblCWKFrontend.localized

  // Global object
  window.CwkSavedContentFunctions = {}

  $(document).ready(function () {
    window.CwkSavedContentFunctions.constructor()
  })

  window.CwkSavedContentFunctions = {

    // initialize the code
    constructor: function () {

      const $_this =this;

      const favorite_actions__js = $('.favorite-actions--js')
      const tgbl_instantsearch_container__js= $('.tgbl-instantsearch-container--js')
      if(favorite_actions__js.length || tgbl_instantsearch_container__js.length) {
        this.saveToFavorites(favorite_actions__js,$_this)
      }
      const user_saved_favorites_list__js = $('.user-saved-favorites-list--js')
      if(user_saved_favorites_list__js.length) {
        this.removeFromSavedFavoritesList(user_saved_favorites_list__js ,$_this)
      }

      const cwk_search_wrapper = $('.cwk-search__wrapper')
      if(cwk_search_wrapper.length) {
        this.toggleSearchFilters(cwk_search_wrapper,$_this)
      }

      //this.toolTip()
    },

    toggleSearchFilters: function(parent,$_this) {
      const toggle_button = parent.find('.toggle-search-panel')

      toggle_button.on('click', function(e){
        e.preventDefault()
        //console.log($(this).attr('href'))
        $($(this).attr('href')).toggleClass('is_visible')
      })
    },

    toolTip: function(type) {

      if(type == undefined) type = 'favorites'

      $( 'body' ).tooltip({
        items: '[data-tooltip_'+type+']',
        content: function() {
          const element = $( this )
          return element.attr('data-tooltip_'+type)
        },
        //position: { my: "left+15 center", at: "right center" },
        position: { my: "right center", at: "left-10 center" },
      })
    },

    saveToFavorites: function (parent,$_this) {

      //console.log($_this)

      $('body').on('click','.favorite-actions--js',function(e){
        e.stopImmediatePropagation()

        console.log(window)

        const $this = $(this)
        const user_id = $this.attr('data-user_id')
        const post_id = $this.attr('data-post_id')
        const post_type = $this.attr('data-post_type')
        const reload_page = ($this.attr('data-reload_page') != undefined) ? $this.attr('data-reload_page') : 0

        // if we are on instantsearch find wrapper
        const ais_pec_item_wrapper = $this.parents('.tt-item__wrapper')
        const ais_container = $this.parents('.tgbl-instantsearch-container--js')

        const data = {
          user_id: user_id,
          post_id: post_id,
        }

        $('.favorite-actions--js').each(function(){
          $(this).css('opacity', '0.2').css('pointer-events', 'none')
        })

        // ajax handle user save resource

        ajax('tgbl_user_saved_favorite_ajax', data)
          .then(function(res) {
            //console.log('RESPONSE --- ',  res)
            $this.attr('data-saved',res.saved)

            // Algolia search client
            const searchClient = algoliasearch(
              window.atob(res.aaid),
              window.atob(res.aak)
            );
            const index = searchClient.initIndex('wp_central_index_lesson_videos');

            if(res.saved === 1){
              $this.addClass('saved').removeClass('not-saved')
              $this.attr('data-tooltip_favorites',LOCALIZED.remove_from_fav_tooltip)
              $this.find('.tt-item__save_to_library_button').hide()
              $this.find('.tt-item__remove_from_library_button').show().find('.favorite-button-text').html(LOCALIZED.remove_from_fav)

              // if we are in ais
              if(ais_pec_item_wrapper.length){
                ais_container.attr('data-user_saved_favorites',JSON.stringify(res.new_saved))
              }

              // update index
              const objectId =post_type+'#'+post_id
              index.getObject(objectId, {
                attributesToRetrieve: ['favorite_for_users']
              }).then(object => {

                const favorite_for_users =[...new Set(object['favorite_for_users'])]   // make the array unique
                favorite_for_users.push(user_id)

                index.partialUpdateObject({
                  favorite_for_users: [...new Set(favorite_for_users)],  // make the array unique
                  objectID: objectId
                }).then(({ objectID }) => {
                  console.log(objectID)
                  if(reload_page){
                    console.log('reload_page ',  reload_page)
                    window.location.reload()
                  }
                })
              })

              setTimeout(function(){
               //$_this.toolTip('favorites')
                //window.CwkSavedContentFunctions.toolTip('favorites')
              }, 400)

              $('.favorite-actions--js').each(function(){
                $(this).css('opacity', '1').css('pointer-events', 'inherit')
              })

            } else if(res.saved === 0){
              $this.removeClass('saved').addClass('not-saved')
              $this.attr('data-tooltip_favorites',LOCALIZED.add_to_fav_tooltip)
              $this.find('.tt-item__save_to_library_button').show().find('.favorite-button-text').html(LOCALIZED.add_to_fav)
              $this.find('.tt-item__remove_from_library_button').hide()

              // if we are on my library page
              const user_saved_favorites_list = $this.parents('.user-saved-favorites-list--js')
              if(user_saved_favorites_list.length) {
                $this.parents('.tt-item--content').remove()
              }

              // if we are in instantsearch
              if(ais_pec_item_wrapper.length){
                ais_container.attr('data-user_saved_favorites',JSON.stringify(res.new_saved))
              }

              // update index
              const objectId =post_type+'#'+post_id
              index.getObject(objectId, {
                attributesToRetrieve: ['favorite_for_users']
              }).then(object => {

                const favorite_for_users =[...new Set(object['favorite_for_users'])]  // make the array unique

                //favorite_for_users.push(user_id)
                const pos = favorite_for_users.lastIndexOf(user_id)

                if(pos !== -1){
                  favorite_for_users.splice(pos,1)

                  index.partialUpdateObject({
                    favorite_for_users: [...new Set(favorite_for_users)],  // make the array unique
                    objectID: objectId
                  }).then(({ objectID }) => {
                    console.log(objectID)
                    if(reload_page){
                      console.log('reload_page ',  reload_page)
                      window.location.reload()
                    }
                  })
                }
              })

              setTimeout(function(){
                //window.CwkSavedContentFunctions.toolTip('favorites')
              }, 400)

              $('.favorite-actions--js').each(function(){
                $(this).css('opacity', '1').css('pointer-events', 'inherit')
              })
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click
    },


    removeFromSavedFavoritesList: function (parent,$_this) {

      $('body').on('click','.favorite-actions-remove--js',function(){
        const $this = $(this)
        const user_id = $this.attr('data-user_id')
        const post_id = $this.attr('data-post_id')
        const post_type = $this.attr('data-post_type')
        const reload_page = $this.attr('data-reload_page')

        const data = {
          user_id: user_id,
          post_id: post_id,
        }

        // spinner
        const spinnerHtml = $(tgblPEFrontend.spinnerHtml)
        $this.parents('.user-saved-favorites-list--js').css('opacity','0.5').append(spinnerHtml)
        spinnerHtml.find('.tgbl-ajax-modal-spinner').show()

        // ajax handle user saved favorite remove

        ajax('tgbl_remove_user_saved_favorites_ajax', data)
          .then(function(res) {

            //console.log('RESPONSE --- ',  res)
            if(res.success == true){
              $this.parents('.user-saved-favorites-list--js').html(res.html).css('opacity','1')
              spinnerHtml.remove()

              // Algolia search client
              const searchClient = algoliasearch(
                window.atob(res.aaid),
                window.atob(res.aak)
              );
              const index = searchClient.initIndex('wp_central_index_lesson_videos');

              // update index
              const objectId =post_type+'#'+post_id  // implode('#', [$post->post_type, $post->ID])
              index.getObject(objectId, {
                attributesToRetrieve: ['favorite_for_users']
              }).then(object => {

                const favorite_for_users =[...new Set(object['favorite_for_users'])]  // make the array unique

                //favorite_for_users.push(user_id)
                const pos = favorite_for_users.lastIndexOf(user_id)

                if(pos !== -1){
                  favorite_for_users.splice(pos,1)

                  index.partialUpdateObject({
                    favorite_for_users: [...new Set(favorite_for_users)],  // make the array unique
                    objectID: objectId
                  }).then(({ objectID }) => {
                    console.log(objectID)
                    if(reload_page){
                      console.log('reload_page ',  reload_page)
                      window.location.reload()
                    }
                  })
                }
              })
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click
    },
  }
}
export {CwkSavedContent}
